export const regexSubDomain = /(https?:\/\/)([^./]+\.)+([^./]+\.[^./]+)/g;
